import { POLICY_DOCUMENTS } from "../../../constants/policy-documents";
import { useIsLoading } from "../hooks/useIsLoading";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Loader } from "./Loader";

export const Layout = ({
  children,
  headerStyle,
  loading,
  waitForPreload = true,
  bgImage,
  header: { show: headerShow = true } = {},
  footer: { show: footerShow = true } = {},
}: {
  children: JSX.Element | undefined | null | (JSX.Element | null | undefined)[];
  headerStyle?: "lg" | "sm";
  waitForPreload?: boolean;
  bgImage?: string;
  header?: { show?: boolean };
  footer?: { show?: boolean };
  loading?: boolean;
}) => {
  const isWaiting = useIsLoading(3000) || loading;

  return (
    <>
      {waitForPreload && isWaiting ? (
        <div className="flex justify-center items-center h-screen gap-2 bg-main/70">
          {/* <Loader showDots={false}> We are loading your content!</Loader> */}
        </div>
      ) : null}
      <div
        id="background image"
        style={{
          // visibility: waitForPreload && isWaiting ? "hidden" : "visible",
          backgroundImage: bgImage,
          // opacity: waitForPreload && isWaiting ? 0 : 1,
          zIndex: -1,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
        className={
          `
        fixed top-0 left-0 right-0 bottom-0
        duration-[10s] 
      ` +
          (waitForPreload && isWaiting
            ? "opacity-0 scale-[180%] translate-x-[30px]"
            : "opacity-1 scale-[150%] translate-x-[-30px] duration-[15s] ")
        }
      ></div>
      <div
        id="page"
        style={{
          visibility: waitForPreload && isWaiting ? "hidden" : "visible",
          zIndex: 1,
        }}
        className={
          `min-h-screen
        bg-main/70
        backdrop-blur-md
        text-textMain
        flex
        flex-col
        justify-between
        duration-[2s] 
      ` + (waitForPreload && isWaiting ? " opacity-0 " : " opacity-1 ")
        }
      >
        {headerShow ? (
          <div id="header view" className="">
            <Header style={headerStyle} />
          </div>
        ) : null}
        <div className="flex-1">{children}</div>
        {footerShow ? (
          <Footer
            policy={POLICY_DOCUMENTS.map(({ slug, label }) => ({
              href: "/policy/" + slug,
              label,
            }))}
            contact={[
              { href: "mailto:contact@doridium.com", label: "Contact us" },
            ]}
          />
        ) : null}
      </div>
    </>
  );
};
